import Client from "./client";

export const GetSwimlanes = (projectId, accessToken) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/swimlanes`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.swimlanes);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateSwimlane = ({projectId, name, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/swimlanes`, {name}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.swimlane);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const ReorderSwimlanes = ({projectId, swimlaneIds, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/projects/${projectId}/swimlanes/reorder`, {swimlaneIds}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.swimlanes);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const RenameSwimlane = ({swimlaneId, name, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/swimlanes/${swimlaneId}`, {name}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.swimlane);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// Without `moveTasks` this is a dry run for a column that still holds tickets:
// the API refuses with the count, where they are and where they would go, which
// is what the confirmation is built from. Sent again with moveTasks it performs
// the move and the delete together.
export const DeleteSwimlane = ({swimlaneId, moveTasks, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/swimlanes/${swimlaneId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
            data: moveTasks ? {moveTasks: true} : undefined,
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
